import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NavigationService} from "./service/navigation-service";
import {AuthenticationService} from "./service/authentication-service";
import {AuthGuardTsGuard} from "./guard/auth-guard.ts.guard";
import {AlreadyAuthGuardTsGuard} from "./guard/already-auth-guard.ts.guard";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {SharedModule} from "./shared/shared.module";
import {EventModule} from "./modules/events/event.module";
import {TokenInterceptor} from "./interceptor/token-interceptor.service";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ConfirmationService, MessageService} from "primeng/api";
import {ToastModule} from "primeng/toast";
import {DialogModule} from "primeng/dialog";
import {ButtonModule} from "primeng/button";
import {InputTextModule} from "primeng/inputtext";
import {TextareaModule} from "primeng/textarea";
import {AccordionModule} from "primeng/accordion";
import {MenuModule} from "primeng/menu";
import {AvatarModule} from "primeng/avatar";
import {HomepageComponent} from "./modules/base/homepage/homepage.component";
import {LoginComponent} from "./modules/base/acesso/login/login.component";
import {TermsConditionComponent} from "./modules/base/terms-condition/terms-condition.component";
import {RegisterComponent} from "./modules/base/acesso/registro/register.component";
import {RecoverPasswordComponent} from "./modules/base/acesso/recover-password/recover-password.component";
import {
  AccountActivationComponent
} from "./modules/base/acesso/activation/account-activation/account-activation.component";
import {FooterComponent} from "./shared/components/footer/footer.component";
import {NavigationComponent} from "./shared/components/navigation/navigation.component";
import {MainlayoutComponent} from "./shared/components/layout/mainlayout/mainlayout.component";
import {AcessolayoutComponent} from "./shared/components/layout/acessolayout/acessolayout.component";
import {AdminLayoutComponent} from "./shared/components/layout/admin-layout/admin-layout.component";
import {DrawerModule} from "primeng/drawer";
import {BreadcrumbModule} from "primeng/breadcrumb";
import {ResponseInterceptor} from "./interceptor/response-interceptor.service";
import {UserModule} from "./modules/user/user.module";
import {DatePipe} from "@angular/common";
import {AdminModule} from "./modules/admin/admin.module";
import {AdminSidebarComponent} from "./shared/components/layout/admin-layout/admin-sidebar/admin-sidebar.component";
import {RolesGuard} from "./guard/roles-guard.ts.guard";
import {RegistroSuccessComponent} from './modules/base/acesso/registro/registro-success/registro-success.component';
@NgModule({ declarations: [
        FooterComponent,
        HomepageComponent,
        NavigationComponent,
        LoginComponent,
        TermsConditionComponent,
        RegisterComponent,
        RecoverPasswordComponent,
        AccountActivationComponent,
        MainlayoutComponent,
        AcessolayoutComponent,
        AdminLayoutComponent,
        AdminSidebarComponent,
        RegistroSuccessComponent,
    ],
    bootstrap: [], imports: [BrowserAnimationsModule,
        AppRoutingModule,
        BrowserModule,
        ReactiveFormsModule,
        FormsModule,
        SharedModule,
        DialogModule,
        ToastModule,
        ButtonModule,
        InputTextModule,
        TextareaModule,
        AccordionModule,
        MenuModule,
        AvatarModule,
        DrawerModule,
        BreadcrumbModule,
        EventModule,
        UserModule,
        AdminModule], providers: [
        DatePipe,
        NavigationService,
        AuthenticationService,
        AuthGuardTsGuard,
        RolesGuard,
        AlreadyAuthGuardTsGuard,
        { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        MessageService,
        ConfirmationService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
